import { FC, PropsWithChildren } from "react";
import Link from "next/link";
import useDevice from "@/hooks/useDevice";

interface Props {
  title: string;
  subTitle?: string;
  moreLink?: string;
  icon?: string;
  hiddenUnderline?: boolean;
}

const SectionContainer: FC<PropsWithChildren<Props>> = ({
  title,
  subTitle,
  moreLink,
  children,
  icon,
  hiddenUnderline,
}): JSX.Element => {
  const { isPc } = useDevice();

  return (
    <section className="space-y-12">
      <div
        className={[
          "flex justify-between items-center mx-8 laptop:mx-0 laptop:px-0 leading-extra-loose",
          hiddenUnderline ? "" : "border-b border-gray-100",
        ].join(" ")}
      >
        <div className="flex items-center space-x-12">
          <div className="flex items-center space-x-4">
            {icon && <i className={`icon-${icon}`} />}
            <h1 className="text-sm font-bold">{title}</h1>
          </div>

          {isPc && subTitle && (
            <p className="text-tiny laptop:text-xs text-secondary">
              {subTitle}
            </p>
          )}
        </div>
        {moreLink && (
          <Link
            href={moreLink}
            prefetch={false}
            className="text-xs text-link font-bold"
          >
            すべて見る
          </Link>
        )}
      </div>
      {children}
    </section>
  );
};

export default SectionContainer;
